function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "shape",
  fill: "#555d64",
  d: "M9.0004,1.0004 L9.0004,5.9994 L6.9994,5.0004 L4.0004,6.9994 L4.9994,11.0004 L12.0004,14.9994 L19.0004,11.0004 L20.0004,6.9994 L16.9994,5.0004 L14.9994,5.9994 L14.9994,1.0004 L9.0004,1.0004 Z M11.0004,5.9994 L11.0004,3.0004 L13.0004,3.0004 L13.0004,5.9994 L12.0004,6.9994 L11.0004,5.9994 Z M15.9994,8.9994 L12.0004,12.0004 L7.9994,8.9994 L12.0004,10.0004 L15.9994,8.9994 Z M12.0001,16.9997 L16.0001,14.9997 L15.0001,21.0007 L16.9991,21.0007 L16.9991,22.9997 L7.0001,22.9997 L7.0001,21.0007 L9.0001,21.0007 L7.9991,14.9997 L12.0001,16.9997 Z"
});

var SvgTower = function SvgTower(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tower.ee086b8c.svg";
export { ForwardRef as ReactComponent };